/* ============================================================
   Paleo Pro theme — global behaviour
   Ported from the standalone pp-site.html build (v17/18).
   The hash router and mock cart are gone: every view is now a real
   Shopify template and the cart drawer talks to the Cart AJAX API.
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- drawer menu ---------- */
  var drawer = $('#drawer'), drawerBg = $('#drawer-bg'), hamb = $('#hamb');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('open'); drawerBg.classList.add('open'); hamb.classList.add('open');
    hamb.setAttribute('aria-expanded', 'true'); drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open'); drawerBg.classList.remove('open'); hamb.classList.remove('open');
    hamb.setAttribute('aria-expanded', 'false'); drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (hamb && drawer) {
    hamb.addEventListener('click', function () { drawer.classList.contains('open') ? closeDrawer() : openDrawer(); });
    drawerBg.addEventListener('click', closeDrawer);
    var dClose = $('#d-close'); if (dClose) dClose.addEventListener('click', closeDrawer);
    $$('a', drawer).forEach(function (a) { a.addEventListener('click', closeDrawer); });
  }
  window.ppCloseDrawer = closeDrawer;

  /* ---------- bag tabs (flavored / naked) ---------- */
  $$('.bag-tabs button').forEach(function (b) {
    b.addEventListener('click', function () {
      var root = b.closest('section') || document;
      $$('.bag-tabs button', root).forEach(function (o) { o.classList.toggle('on', o === b); });
      $$('.bag-pane', root).forEach(function (p) {
        var on = p.dataset.pane === b.dataset.pane;
        p.classList.toggle('on', on);
        if (on) $$('.reveal', p).forEach(function (r) { r.classList.add('in'); });
      });
    });
  });

  /* ---------- carousels ---------- */
  function initCarousel(car) {
    if (car.dataset.carReady) return; car.dataset.carReady = '1';
    var track = $('.track', car); if (!track) return;
    var items = Array.prototype.slice.call(track.children), dots = $('.car-dots', car);
    var prev = $('[data-prev]', car), next = $('[data-next]', car);
    if (dots) { dots.innerHTML = ''; items.forEach(function (_, i) { var d = document.createElement('i'); d.addEventListener('click', function () { go(i); }); dots.appendChild(d); }); }
    function idx() { var x = track.scrollLeft, best = 0, bd = 1e9; items.forEach(function (it, i) { var d = Math.abs(it.offsetLeft - track.offsetLeft - x); if (d < bd) { bd = d; best = i; } }); return best; }
    function go(i) { i = Math.max(0, Math.min(items.length - 1, i)); track.scrollTo({ left: items[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }
    function paint() {
      var i = idx();
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
      var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.style.opacity = i === 0 ? .4 : 1; if (next) next.style.opacity = end ? .4 : 1;
    }
    if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
    if (next) next.addEventListener('click', function () { go(idx() + 1); });
    track.addEventListener('scroll', paint, { passive: true }); paint();
    var auto = +car.dataset.auto;
    if (auto && !reduce) {
      var t;
      var tick = function () { var i = idx(); var end = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; go(end ? 0 : i + 1); };
      var start = function () { stop(); t = setInterval(tick, auto); }, stop = function () { clearInterval(t); };
      car.addEventListener('mouseenter', stop); car.addEventListener('mouseleave', start);
      car.addEventListener('touchstart', stop, { passive: true });
      track.scrollLeft = 0;
      var vis = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { if (!vis.started) { vis.started = true; track.scrollTo({ left: 0, behavior: 'auto' }); } start(); } else stop(); }); }, { threshold: .35 });
      vis.observe(car);
    }
  }
  $$('[data-car]').forEach(initCarousel);

  /* ---------- sticky nav shadow ---------- */
  var nav = $('#topnav');
  if (nav) addEventListener('scroll', function () { nav.classList.toggle('scrolled', scrollY > 8); }, { passive: true });

  /* ---------- scroll reveals ---------- */
  var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12, rootMargin: '0px 0px -40px 0px' });
  function observeReveals(root) { $$('.reveal', root).forEach(function (el) { io.observe(el); }); }
  observeReveals(document);
  if (reduce) $$('.reveal').forEach(function (el) { el.classList.add('in'); });
  function revealVisible() { [300, 900, 1600].forEach(function (t) { setTimeout(function () { $$('.reveal:not(.in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight + 200 && r.bottom > -200) el.classList.add('in'); }); }, t); }); }
  revealVisible();

  /* ---------- FAQ: one open at a time, topic tabs, animated close ---------- */
  function initFaq(root) {
    var items = $$('.faq details', root);
    items.forEach(function (d) {
      if (d.dataset.faqReady) return; d.dataset.faqReady = '1';
      d.addEventListener('toggle', function () { if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; }); });
      var s = $('summary', d), a = $('.a', d); if (!s || !a) return;
      s.addEventListener('click', function (e) {
        if (!d.open || reduce) return;
        e.preventDefault();
        var h = a.offsetHeight;
        var an = a.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 200, easing: 'ease' });
        an.onfinish = function () { d.open = false; a.style.height = ''; };
      });
    });
    var tabs = $$('.faq-tabs button', root);
    tabs.forEach(function (b) {
      b.addEventListener('click', function () {
        tabs.forEach(function (o) { o.classList.toggle('on', o === b); });
        var f = b.dataset.fq;
        items.forEach(function (d) { var show = f === 'all' || d.dataset.fq === f; d.classList.toggle('fq-hide', !show); if (!show) d.open = false; });
        var first = items.filter(function (d) { return !d.classList.contains('fq-hide'); })[0];
        if (first && f !== 'all') { first.open = true; first.classList.remove('fq-flash'); void first.offsetWidth; first.classList.add('fq-flash'); }
      });
    });
  }
  $$('.faq-sec, .faq').forEach(function (r) { initFaq(r.closest('section') || r); });

  /* ---------- shop filters (client-side, on the collection grid) ---------- */
  $$('.filters button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.filters button').forEach(function (o) { o.classList.remove('on'); });
      b.classList.add('on');
      var f = b.dataset.f;
      $$('.shop-all .pcard').forEach(function (c) { c.classList.toggle('hide', f !== 'all' && c.dataset.cat !== f); });
    });
  });

  /* ---------- PDP: gallery + flavor image swap ---------- */
  function swapPdpImage(view, src, isPhoto, key) {
    var img = $('.pdp-fig img', view);
    if (!img || !src) return;
    img.style.opacity = 0;
    setTimeout(function () { img.src = src; img.classList.toggle('photo', !!isPhoto); img.style.opacity = 1; }, 180);
    $$('.pdp-gal button', view).forEach(function (b) { b.classList.toggle('on', b.dataset.src === src); });
  }
  $$('.pdp-gal button').forEach(function (b) {
    b.addEventListener('click', function () { swapPdpImage(b.closest('main') || document, b.dataset.src, b.classList.contains('photo'), b.dataset.img); });
  });
  // The lp-buy-box (v2) exposes its flavor radios as [data-lb2="flavor-input"].
  // When the theme gallery is in use, map the chosen flavor to a gallery thumb.
  document.addEventListener('change', function (e) {
    var t = e.target; if (!t || t.getAttribute('data-lb2') !== 'flavor-input') return;
    var view = t.closest('main') || document;
    var flavor = (t.value || '').toLowerCase();
    var btn = $$('.pdp-gal button[data-flavor]', view).filter(function (b) { return (b.dataset.flavor || '').toLowerCase() === flavor; })[0];
    if (btn) swapPdpImage(view, btn.dataset.src, false);
  });

  /* ---------- PDP: sticky bar (desktop) → drives the buy box CTA ---------- */
  var pdpBar = $('.pdp-bar');
  if (pdpBar) {
    addEventListener('scroll', function () { pdpBar.classList.toggle('show', scrollY > 620); }, { passive: true });
  }
  // Any secondary "Add to Cart" button on a PDP (sticky bar, guarantee block)
  // clicks the real buy-box CTA so the selected flavor/pack/plan is honoured.
  $$('.add-cart').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var atc = $('[data-lb2="atc"]') || $('.lp-buy__atc') || $('form[action*="/cart/add"] [type="submit"]');
      if (atc) {
        var box = atc.closest('.lb2, .lp-buy, form');
        if (b.dataset.scroll === 'true' && box) { box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        atc.click();
        var t = b.textContent; b.textContent = 'Added ✓'; setTimeout(function () { b.textContent = t; }, 900);
      } else {
        window.location.href = b.getAttribute('href') || '/collections/all';
      }
    });
  });

  /* ---------- science "built on purpose" deck ---------- */
  (function () {
    var track = $('#why-track'), sec = $('#sci-why');
    if (!track || !sec) return;
    var cards = $$('.why-card', track), dotsWrap = $('.why-dots', sec);
    cards.forEach(function (c, i) { var d = document.createElement('i'); if (i === 0) d.classList.add('on'); d.addEventListener('click', function () { activate(cards[i]); }); dotsWrap.appendChild(d); });
    var dots = Array.prototype.slice.call(dotsWrap.children);
    function activate(card) {
      cards.forEach(function (c, i) { var on = c === card; c.classList.toggle('on', on); c.setAttribute('aria-pressed', on); dots[i].classList.toggle('on', on); });
      sec.dataset.tone = card.dataset.tone;
      var r = card.getBoundingClientRect(), t = track.getBoundingClientRect();
      track.scrollBy({ left: r.left - t.left - (t.width - r.width) / 2, behavior: 'smooth' });
    }
    cards.forEach(function (c) {
      c.addEventListener('click', function () { activate(c); });
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(c); } });
    });
  })();

  /* ---------- site search (Shopify predictive search + page shortcuts) ---------- */
  (function () {
    var btn = $('#search-btn'), bg = $('#search-bg'), box = $('#search'), inp = $('#search-input'),
        res = $('#search-results'), hint = $('#search-hint'), closeBtn = $('#search-close');
    if (!btn || !box) return;
    var PAGES = window.ppSearchPages || [];
    var strip = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
    var esc = function (s) { return String(s).replace(/</g, '&lt;'); };
    var timer = null, lastQ = '';
    function hi(t, q) { var out = esc(t); q.forEach(function (w) { if (!w) return; out = out.replace(new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); }); return out; }
    function renderPages(raw, q) {
      var hits = PAGES.map(function (p) { var s = 0, t = p.t.toLowerCase(), d = (p.d || '').toLowerCase(), k = (p.k || '').toLowerCase(); q.forEach(function (w) { if (t.indexOf(w) === 0) s += 6; else if (t.indexOf(w) > -1) s += 4; if (d.indexOf(w) > -1) s += 2; if (k.indexOf(w) > -1) s += 1; }); return { p: p, s: s }; }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 6);
      if (!hits.length) return '';
      return '<div class="s-group">Pages</div>' + hits.map(function (x) { return '<a href="' + x.p.h + '"><span class="s-ic">→</span><span><span class="s-t">' + hi(x.p.t, q) + '</span><span class="s-d">' + esc(x.p.d || '') + '</span></span><span class="s-go">→</span></a>'; }).join('');
    }
    function render() {
      var raw = strip(inp.value).toLowerCase(), q = raw.split(' ').filter(Boolean);
      hint.hidden = !!raw;
      if (!raw) { res.innerHTML = ''; return; }
      if (raw === lastQ) return; lastQ = raw;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(raw) + '&resources[type]=product,article&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var html = '';
            var prods = (j.resources && j.resources.results && j.resources.results.products) || [];
            var arts = (j.resources && j.resources.results && j.resources.results.articles) || [];
            if (prods.length) html += '<div class="s-group">Products</div>' + prods.map(function (p) { return '<a href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="">' : '<span class="s-ic">→</span>') + '<span><span class="s-t">' + hi(p.title, q) + '</span><span class="s-d">' + esc(p.price ? '$' + p.price : '') + '</span></span><span class="s-go">→</span></a>'; }).join('');
            if (arts.length) html += '<div class="s-group">Field Journal</div>' + arts.map(function (a) { return '<a href="' + a.url + '"><span class="s-ic">✎</span><span><span class="s-t">' + hi(a.title, q) + '</span><span class="s-d">' + esc(a.summary_html ? strip(a.summary_html.replace(/<[^>]+>/g, '')).slice(0, 90) : '') + '</span></span><span class="s-go">→</span></a>'; }).join('');
            html += renderPages(raw, q);
            html += '<a href="/search?q=' + encodeURIComponent(raw) + '" class="s-all"><span class="s-ic">⌕</span><span><span class="s-t">See all results for “' + esc(raw) + '”</span></span><span class="s-go">→</span></a>';
            res.innerHTML = html;
            var first = $('a', res); if (first) first.classList.add('sel');
          })
          .catch(function () { res.innerHTML = renderPages(raw, q) || '<div class="s-empty">Nothing for “' + esc(raw) + '” — try a product, flavor, or question.</div>'; });
      }, 160);
    }
    function open() { closeDrawer(); if (window.ppCart) window.ppCart.close(); box.classList.add('open'); bg.classList.add('open'); box.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(function () { inp.focus(); }, 60); render(); }
    function close() { box.classList.remove('open'); bg.classList.remove('open'); box.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    btn.addEventListener('click', open); bg.addEventListener('click', close); closeBtn.addEventListener('click', close);
    inp.addEventListener('input', render);
    $$('button', hint).forEach(function (b) { b.addEventListener('click', function () { inp.value = b.dataset.q; lastQ = ''; render(); inp.focus(); }); });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box.classList.contains('open')) close();
      if ((e.key === '/' || ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k')) && !box.classList.contains('open') && !/INPUT|TEXTAREA/.test(document.activeElement.tagName)) { e.preventDefault(); open(); }
      if (!box.classList.contains('open')) return;
      var items = $$('a', res); if (!items.length) return;
      var i = items.findIndex(function (a) { return a.classList.contains('sel'); });
      if (e.key === 'ArrowDown') { e.preventDefault(); i = (i + 1) % items.length; }
      else if (e.key === 'ArrowUp') { e.preventDefault(); i = (i - 1 + items.length) % items.length; }
      else if (e.key === 'Enter') { e.preventDefault(); items[Math.max(0, i)].click(); return; }
      else return;
      items.forEach(function (a, k) { a.classList.toggle('sel', k === i); }); items[i].scrollIntoView({ block: 'nearest' });
    });
  })();

  /* ---------- cart drawer (Shopify Cart AJAX API) ---------- */
  (function () {
    var cartDrawer = $('#cart-drawer'), cartBg = $('#cart-bg');
    if (!cartDrawer) return;
    var cdBody = $('#cd-body'), cdMsg = $('#cd-msg'), cdFill = $('#cd-fill'), cdFoot = $('#cd-foot'), cdTotal = $('#cd-total');
    var cfg = window.ppCartConfig || {};
    var freeShip = +cfg.freeShipping || 70, giftAt = +cfg.giftThreshold || 0, currency = cfg.currency || 'USD';
    var busy = false;
    function money(cents) { return (typeof Shopify !== 'undefined' && Shopify.formatMoney) ? Shopify.formatMoney(cents, cfg.moneyFormat || '${{amount}}') : '$' + (cents / 100).toFixed(2); }
    function open() { closeDrawer(); cartDrawer.classList.add('open'); cartBg.classList.add('open'); cartDrawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
    function close() { cartDrawer.classList.remove('open'); cartBg.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    function render(cart) {
      var count = cart.item_count || 0, sub = cart.items_subtotal_price || 0, basis = typeof cart.total_price === 'number' ? cart.total_price : sub;
      $$('.cart-n').forEach(function (n) { n.textContent = count; });
      var goal = giftAt || freeShip;
      if (cdFill) cdFill.style.width = Math.min(basis / (goal * 100) * 100, 100) + '%';
      if (cdMsg) {
        if (sub === 0) cdMsg.textContent = cfg.msgEmpty || ('Free shipping at ' + money(freeShip * 100));
        else if (basis < freeShip * 100) cdMsg.textContent = "You're " + money(freeShip * 100 - basis) + ' away from FREE shipping';
        else if (giftAt && basis < giftAt * 100) cdMsg.textContent = 'Free shipping unlocked! ' + money(giftAt * 100 - basis) + ' away from ' + (cfg.giftLabel || 'a free gift');
        else cdMsg.textContent = giftAt ? (cfg.msgUnlockedAll || 'Unlocked: FREE shipping + your free gift!') : 'Free shipping unlocked!';
      }
      if (!cart.items || !cart.items.length) {
        cdFoot.hidden = true;
        cdBody.innerHTML = '<div class="cd-empty"><p><b>Your cart is empty.</b></p><p style="font-size:16px;color:var(--olive)">' + (cfg.emptyLine || 'Two clean proteins, one complete scoop — and 60 days to decide.') + '</p><a class="btn" href="' + (cfg.emptyUrl || '/collections/all') + '">' + (cfg.emptyCta || 'Try Paleo Pro Risk-Free') + '</a><p class="cd-note">' + (cfg.emptyNote || '') + '</p></div>';
        return;
      }
      cdFoot.hidden = false;
      // Code discounts (e.g. CARNIVORE12 via a /discount link) are cart-level: show them and total after them (2026-10-20).
      var total = typeof cart.total_price === 'number' ? cart.total_price : sub, off = Math.max(0, sub - total);
      cdTotal.textContent = money(total);
      var cdDisc = $('#cd-discount');
      if (cdDisc) {
        var codes = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; }).join(', ');
        cdDisc.hidden = !off;
        cdDisc.innerHTML = off ? '<span>' + (codes || 'Discount') + ' applied</span><span>&minus;' + money(off) + '</span>' : '';
      }
      cdBody.innerHTML = cart.items.map(function (i) {
        var plan = i.selling_plan_allocation ? '<div class="cd-plan">' + i.selling_plan_allocation.selling_plan.name + '</div>' : '';
        var variant = (i.variant_title && i.variant_title !== 'Default Title') ? '<div class="cd-var">' + i.variant_title + '</div>' : '';
        return '<div class="cd-item" data-key="' + i.key + '"><img src="' + (i.image ? i.image.replace(/(\.[a-z]+)(\?.*)?$/, '_240x$1$2') : '') + '" alt=""><div><div class="nm">' + i.product_title + '</div>' + variant + plan + '<div class="cd-qty"><button data-a="-" aria-label="Decrease">−</button><b>' + i.quantity + '</b><button data-a="+" aria-label="Increase">+</button></div></div><span class="pr">' + money(i.final_line_price) + '</span><button class="rm" data-a="x" aria-label="Remove">×</button></div>';
      }).join('');
      $$('button[data-a]', cdBody).forEach(function (b) {
        b.addEventListener('click', function () {
          var row = b.closest('.cd-item'), key = row.dataset.key, q = +$('b', row).textContent, a = b.dataset.a;
          var nq = a === '+' ? q + 1 : a === '-' ? Math.max(0, q - 1) : 0;
          change(key, nq);
        });
      });
    }
    function refresh(thenOpen) {
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { render(c); if (thenOpen) open(); return c; }).catch(function () {});
    }
    function change(key, quantity) {
      if (busy) return; busy = true;
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ id: key, quantity: quantity }) })
        .then(function (r) { return r.json(); }).then(function (c) { busy = false; render(c); }).catch(function () { busy = false; refresh(); });
    }
    $$('.nav-ic[aria-label="Cart"], [data-open-cart]').forEach(function (a) { a.addEventListener('click', function (e) { e.preventDefault(); refresh(true); }); });
    var cdClose = $('#cd-close'); if (cdClose) cdClose.addEventListener('click', close);
    cartBg.addEventListener('click', close);
    addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    document.addEventListener('cart:refresh', function () { refresh(false); });
    document.documentElement.addEventListener('cart:updated', function () { refresh(false); });
    document.addEventListener('cart:open', function () { refresh(true); });
    window.ppCart = { open: function () { refresh(true); }, close: close, refresh: refresh };
    refresh(false);
  })();

  /* ---------- Shopify theme editor: re-init sections when they load ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-car]', e.target).forEach(initCarousel);
    observeReveals(e.target); revealVisible();
    initFaq(e.target);
  });
})();
